import React from 'react'

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2'
  
  const variants = {
    primary: 'bg-navy-medium hover:bg-navy-base text-white shadow-lg hover:shadow-xl focus:ring-navy-light hover:shadow-accent/20 dark:bg-github-green dark:hover:bg-[#2ea043] dark:text-github-text dark:focus:ring-github-border/50',
    secondary: 'bg-white dark:bg-github-border-muted text-navy-dark dark:text-github-text border-2 border-navy-soft dark:border-github-border hover:border-accent hover:text-accent dark:hover:bg-github-border',
    outline: 'border-2 border-navy-medium text-navy-medium hover:bg-navy-medium hover:text-white focus:ring-navy-light dark:border-github-border dark:text-github-text dark:hover:bg-github-border/20',
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  }
  
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`
  
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    )
  }
  
  return (
    <button onClick={onClick} className={classes} {...props}>
      {children}
    </button>
  )
}

export default Button